import { render, staticRenderFns } from "./SexManageView.vue?vue&type=template&id=bc04a5fe&scoped=true&"
import script from "./SexManageView.vue?vue&type=script&lang=js&"
export * from "./SexManageView.vue?vue&type=script&lang=js&"
import style0 from "./SexManageView.vue?vue&type=style&index=0&id=bc04a5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc04a5fe",
  null
  
)

export default component.exports